import {Component, Input} from "@angular/core";
import {ModalController} from "@ionic/angular";

@Component({
  selector: "app-confirm-modal",
  standalone: false,
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ["./confirm-modal.component.scss"],
})
export class ConfirmModalComponent {
  @Input() title = "Bist du sicher?";
  @Input() message = "Bitte bestätige deine Auswahl.";
  @Input() yesLabel = "Ja";
  @Input() noLabel = "Nein";
  @Input() danger = false; // setzt Yes-Button auf "danger"

  constructor(private modalCtrl: ModalController) {
  }

  cancel() {
    this.modalCtrl.dismiss(false, "cancel");
  }

  confirm() {
    this.modalCtrl.dismiss(true, "confirm");
  }
}
